<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
  >
    <!-- <template #TEST="{field,row}">
        <Button>{{row[field.key]}}</Button>
      </template> -->
  </cTable>
</template>

<script>
import {
  add,
  getAirport,
  getDetails,
  update,
  del
} from "@/api/system/airportList";

import cTable from "@/base/common/index";
export default {
  name: "airport",

  components: {
    cTable
  },
  data() {
    return {
      methods: {
        list: getAirport,
        getDetails,
        del,
        add,
        update
      },
      config: {
        height: 630
      },
      modals: {
        add: {
          methods: {
            ok({ row, close }) {
              let data = row;
              this.$page.handleRequestMethods(this.type, data).then(res => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg
                });
                this.$page.getList();
                close();
              });
            }
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true
            },
            formBind: {
              labelWidth: 120
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              title: [
                {
                  required: true,
                  message: "Name cannot be empty",
                  trigger: "blur"
                },
                {
                  max: 55,
                  message: "Please enter maximum 55",
                  trigger: "blur"
                }
              ],
              code: [
                {
                  required: true,
                  message: "Code cannot be empty",
                  trigger: "blur"
                },
                {
                  max: 15,
                  message: "Please enter maximum 15",
                  trigger: "blur"
                }
              ],
              status: [
                {
                  required: true,
                  message: "status cannot be empty",
                  trigger: "change"
                }
              ],
              country: [
                {
                  required: true,
                  message: "country cannot be empty",
                  trigger: "blur"
                },
                {
                  max: 55,
                  message: "Please enter maximum 55",
                  trigger: "blur"
                }
              ]
            }
          },
          grid: [{ title: 24 }, { code: 24 }, { status: 24 }, { country: 24 }],
          fields: [
            {
              name: () => this.$t("airport_name"),
              key: "title",
              component: "Input",
              // bind: {
              //   placeholder: "Enter name"
              // },
              placeholder() {
                return this.$t("enter") + this.$t("airport_name");
              }
            },
            {
              name: () => this.$t("tip"),
              key: "status",
              component: "Radio",
              bind: {
                border: true
              },
              options: [
                { label: this.$t("enable"), value: "ENABLE" },
                { label: this.$t("disable"), value: "DISABLE" }
              ],
              // bind: {
              //   placeholder: "Enter code"
              // },
              placeholder() {
                return this.$t("select") + this.$t("tip");
              }
            },
            {
              name: () => this.$t("airport_code"),
              key: "code",
              component: "Input",
              // bind: {
              //   placeholder: "Enter code"
              // },
              placeholder() {
                return this.$t("enter") + this.$t("airport_name");
              }
            },
            {
              name: () => this.$t("countryCode"),
              key: "country",
              component: "Input",
              // bind: {
              //   placeholder: "Enter code"
              // },
              placeholder() {
                return this.$t("enter") + this.$t("countryCode");
              }
            }
          ]
        }
      },
      header: {
        config: {
          custom: false
        },
        searchs: [
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input"
            // bind: {
            //   type: "textarea",
            //   autosize: { minRows: 2, maxRows: 2 }
            // }
          }
          // {
          //   key: "ClientId",
          //   type: "select",
          //   placeholder() {
          //     return this.$t("select") + this.$t("clientName");
          //   },
          //   clearable: true,
          //   options: [],
          //   config: { label: "account", value: "id" }
          // }
        ],
        btns: {
          list: [
            {
              name: () => this.$t("add"),
              type: "add",
              fnName: "add",
              bind: {
                icon: "md-add",
                type: "warning"
              },
              id: 860
            },
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "export",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                icon: "md-arrow-down",
                type: "primary"
              }
            }
          ],
          methods: {
            export() {
              this.exportExc();
            },
            add() {
              this.getModal("add").open(null, () => {
                this.getModal("add").setTitle(this.$t("add"));
                this.getModal("add").type = "add";
              });
            }
          }
        }
      },
      fields: [
        {
          type: "checkbox",
          align: "center",
          width: 60
        },
        // {
        //   name: "序号",
        //   type: "seq",
        //   align: "center",
        //   width: 50
        // },
        {
          name: () => this.$t("airport_name"),
          key: "title",
          align: "center"
        },
        {
          name: () => this.$t("airport_code"),
          key: "code",
          align: "center"
        },
        {
          name: () => this.$t("tip"),
          key: "status",
          align: "center",
          methods: {
            render({ row }) {
              return row.status === "ENABLE"
                ? this.$t("enable")
                : this.$t("disable");
            }
          }
        },
        {
          name: () => this.$t("countryCode"),
          key: "country",
          align: "center"
        },
        {
          type: "btns",
          width: 150,
          name: () => this.$t("operation"),
          fixed: "right",
          // width({ field }) {
          //   return field.list.length * 40 + 40;
          // },
          list: [
            {
              name: () => this.$t("update"),
              type: "update",
              fnName: "update",
              bind: {
                type: "success"
              },
              id: 858
            },
            {
              name: () => this.$t("delete"),
              type: "delete",
              fnName: "delete",
              id: 857

              // bind: {
              //   type: "error"
              // }
            }
          ],
          methods: {
            update({ row }) {
              this.handleRequestMethods("getDetails", row.id).then(res => {
                this.getModal("add").setTitle(this.$t("update"));
                this.getModal("add").type = "update";
                this.getModal("add").open(res.payload);
              });
            },
            delete({ row }) {
              this.$Modal.confirm({
                title: this.$t("delete"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods("del", row.id).then(res => {
                    this.$Message["success"]({
                      background: true,
                      content: res.msg
                    });
                    this.getList();
                  });
                }
              });
            }
          }
        }
      ]
    };
  }
};
</script>
